export const stringifySet = value => {
  return `${value.length}`;
};